<template>
    <div class="main">
      <b-card>
        <b-card-body>
          <b-row class="mb-2">
            <b-col md="12" class="d-flex justify-content-end">
              <!-- Button to trigger the modal -->
              <b-button variant="primary" @click="showAddEmployeeTrainingModal">
                <feather-icon icon="PlusIcon" class="mr-1" />
                New Training
              </b-button>
              <b-button       variant="outline-success" class="ml-2" @click="exportToCSV">
                <feather-icon icon="DownloadIcon" class="mr-50" />
                Export to Excel
              </b-button>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col md="2" sm="4" class="my-1">
              <b-form-group class="mb-0">
                <label class="d-inline-block text-sm-left mr-1">Per page</label>
                <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-75" />
              </b-form-group>
            </b-col>
            <b-col md="6" class="my-1">
              <b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm"
                label-for="filterInput" class="mb-0">
                <b-input-group size="sm">
                  <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Type to Search" />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">
                      Clear
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
  
          <b-row>
            <b-col cols="12">
              <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredEmployeeTrainings"
                :fields="employeeTrainingFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                
                <template #cell(status)="data">
                    <b-badge :style="{ backgroundColor: getBadgeColor(data.item.status) }">
                        {{ getStatusText(data.item.status) }}
                      </b-badge>
                  </template>

                <template #cell(certificationDate)="data">
                    {{ formatCertificationDate(data.item) }}
                  </template>
                  <template #cell(trainingDate)="data">
                    {{ formatTrainingDate(data.item) }}
                  </template>
  
                <template #cell(actions)="data">
                  <b-dropdown variant="link" toggle-class="p-0" no-caret class="m-1">
                    <template #button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                    </template>
                    <b-dropdown-item @click="showViewEmployeeTrainingModal(data.item)">
                      <feather-icon icon="EyeIcon" />
                      <span class="align-middle ml-1">View</span>
                    </b-dropdown-item>
                    <b-dropdown-item v-b-modal.modalEditEmployeeTraining @click="showEditEmployeeTrainingModal(data.item)">
                      <feather-icon icon="EditIcon" />
                      <span class="align-middle ml-1">Edit</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="confirmDeleteEmployeeTraining(data.item.id)">
                      <feather-icon icon="TrashIcon" />
                      <span class="align-middle ml-1">Delete</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </b-col>
          </b-row>
  
          <b-row>
            <b-col cols="12">
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
                class="my-0" />
              <b-form-group>
                Showing 
                {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
                to 
                {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
                of 
                {{ totalRows > 0 ? totalRows : 0 }} 
                entries
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
      <b-modal ref="modalAddEmployeeTraining" id="modal-add-employee-training" title="Add Training" centered hide-footer>
        <validation-observer ref="AddEmployeeTrainingForm" v-slot="{ invalid, handleSubmit }">
          <b-form @submit.prevent="handleSubmit(addNewEmployeeTraining)">
            <b-row>
                   <!-- Training Name -->
        <b-col cols="12">
            <b-form-group label="Training Name" label-for="trainingName">
              <validation-provider name="Training Name" rules="required" v-slot="{ errors }">
                <b-form-input id="trainingName" v-model="formData.trainingName" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
  
          <!-- Provider -->
          <b-col cols="12">
            <b-form-group label="Provider" label-for="provider">
              <validation-provider name="Provider" rules="required" v-slot="{ errors }">
                <b-form-input id="provider" v-model="formData.provider" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
  
          <!-- Training Date -->
          <b-col cols="12">
            <b-form-group label="Training Date" label-for="trainingDate">
                <b-form-datepicker id="trainingDate" v-model="formData.trainingDate" />
            </b-form-group>
          </b-col>

          <!-- Certification Date -->
          <b-col cols="7" v-if="formData.certificationIssued">
            <b-form-group label="Certification Date" label-for="certificationDate">
                <b-form-datepicker id="certificationDate" v-model="formData.certificationDate" />
            </b-form-group>
          </b-col>
  
          <!-- Status -->
          <b-col cols="5">
            <b-form-group label="Status" label-for="status">
                <b-form-select id="status" v-model="formData.status" :options="statusOptions">
                  <template #first>
                    <option disabled value="">select status</option>
                  </template>
                </b-form-select>
            </b-form-group>
          </b-col>

          
  
           <!-- Cost -->
           <b-col cols="6">
            <b-form-group label="Cost" label-for="cost">
              <validation-provider name="Cost" rules="required" v-slot="{ errors }">
                <b-form-input id="cost" type="number" v-model="formData.cost" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
  
          <!-- Budget -->
          <b-col cols="6">
            <b-form-group label="Budget" label-for="budget">
              <validation-provider name="Budget" rules="required" v-slot="{ errors }">
                <b-form-input id="budget" type="number" v-model="formData.budget" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

            <!-- Score -->
            <b-col cols="6">
              <b-form-group label="Score" label-for="score">
                <validation-provider name="Score" rules="required" v-slot="{ errors }">
                  <b-form-input id="score" type="number" v-model="formData.score" />
                  <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
              </b-form-group>
            </b-col>

             <!-- Rating -->
           <b-col cols="6">
            <b-form-group label="Rating" label-for="rating">
              <validation-provider name="Rating" rules="required" v-slot="{ errors }">
                <b-form-input id="rating" type="number" v-model="formData.rating" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
  
          <!-- Training Type -->
          <b-col cols="6">
            <b-form-group label="TrainingType" label-for="trainingtype">
                <b-form-select id="trainingType" v-model="formData.trainingType" :options="trainingOptions">
                  <template #first>
                    <option disabled value="">select Training Type</option>
                  </template>
                </b-form-select>
            </b-form-group>
          </b-col>
  
          <!-- Feedback -->
          <b-col cols="12">
            <b-form-group label="Feedback" label-for="feedback">
                <b-form-textarea id="feedback" v-model="formData.feedback" />
            </b-form-group>
          </b-col>
  
          <!-- Training Description -->
          <b-col cols="12">
            <b-form-group label="Training Description" label-for="trainingDescription">
                <b-form-textarea id="trainingDescription" v-model="formData.trainingDescription" />
            </b-form-group>
          </b-col>
  
          <!-- Certification Issued -->
          <b-col cols="12">
            <b-form-group   label-for="certificationIssued">
              <b-form-checkbox id="certificationIssued" v-model="formData.certificationIssued">
                Is Certificate Issued?
              </b-form-checkbox>
            </b-form-group>
          </b-col>
 
            </b-row>
            <b-button type="submit" variant="primary" @click="addNewEmployeeTraining">
              <b-spinner small v-if="submitting"></b-spinner>
              {{ submitting ? 'Adding...' : 'Add Training' }}
            </b-button>
          </b-form>
        </validation-observer>
      </b-modal>
      <!-- Modal for viewing a training -->
      <b-modal ref="modalViewEmployeeTraining" title="View Training" cancel-variant="outline-secondary" hide-footer centered>
          <b-form @submit.prevent>
            <b-row>
               <!-- Training Name -->
              <b-col cols="12">
                  <b-form-group label="Training Name" label-for="trainingName">
                    <b-form-input id="trainingName" v-model="viewFormData.trainingName" readonly/>
                  </b-form-group>
                </b-col>
                
                <!-- Provider -->
                <b-col cols="12">
                  <b-form-group label="Provider" label-for="provider">
                    <b-form-input id="provider" v-model="viewFormData.provider" readonly/>
                  </b-form-group>
                </b-col>
                
                <!-- Training Date -->
                <b-col cols="12">
                  <b-form-group label="Training Date" label-for="trainingDate">
                    <b-form-datepicker id="trainingDate" v-model="viewFormData.trainingDate" disabled
                    readonly/>
                  </b-form-group>
                </b-col>

                <!-- Certification Date -->
                <b-col cols="7" v-if="viewFormData.certificationIssued">
                  <b-form-group label="Certification Date" label-for="certificationDate">
                    <b-form-datepicker id="certificationDate" v-model="viewFormData.certificationDate"  disabled
                    readonly />
                  </b-form-group>
                </b-col>
                
                <!-- Status -->
                <b-col cols="5">
                  <b-form-group label="Status" label-for="status">
                    <b-form-select id="status" v-model="viewFormData.status" :options="statusOptions"  disabled
                    readonly>
                      <template #first>
                        <option disabled value="">Please select a status</option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>

                <!-- Cost -->
                <b-col cols="6">
                  <b-form-group label="Cost" label-for="cost">
                    <b-form-input id="cost" type="number" v-model="viewFormData.cost" readonly/>
                  </b-form-group>
                </b-col>

                  
                <!-- Budget -->
                <b-col cols="6">
                  <b-form-group label="Budget" label-for="budget">
                    <b-form-input id="budget" type="number" v-model="viewFormData.budget" readonly/>
                  </b-form-group>
                </b-col>
                
                <!-- Score -->
                <b-col cols="6">
                  <b-form-group label="Score" label-for="score">
                    <b-form-input id="score" type="number" v-model="viewFormData.score" readonly/>
                  </b-form-group>
                </b-col>
                
              
                
                <!-- Rating -->
                <b-col cols="6">
                  <b-form-group label="Rating" label-for="rating">
                    <b-form-input id="rating" type="number" v-model="viewFormData.rating" readonly/>
                  </b-form-group>
                </b-col>

                <b-col cols="6">
                          <b-form-group label="TrainingType" label-for="trainingtype">
                            <validation-provider name="TrainingType" rules="required" v-slot="{ errors }">
                              <b-form-select id="trainingType" v-model="viewFormData.trainingType" :options="trainingOptions" disabled>
                                <template #first>
                                  <option disabled value="">select Training Type</option>
                                </template>
                              </b-form-select>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
              
                <!-- Feedback -->
                <b-col cols="12">
                  <b-form-group label="Feedback" label-for="feedback">
                    <b-form-textarea id="feedback" v-model="viewFormData.feedback" readonly />
                  </b-form-group>
                </b-col>
                
                <!-- Training Description -->
                <b-col cols="12">
                  <b-form-group label="Training Description" label-for="trainingDescription">
                    <b-form-textarea id="trainingDescription" v-model="viewFormData.trainingDescription" readonly/>
                  </b-form-group>
                </b-col>
                
                <!-- Certification Issued -->
                <b-col cols="12">
                  <b-form-group   label-for="certificationIssued">
                    <b-form-checkbox id="certificationIssued" v-model="viewFormData.certificationIssued"  disabled
                    readonly>
                      Is Certificate Issued?
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
  
            </b-row>
          </b-form>
      </b-modal>
  
  
      <!-- Modal for editing a training -->
      <b-modal ref="modalEditEmployeeTraining" id="modal-edit-employee-training" title="Edit Training" cancel-variant="outline-secondary" hide-footer centered>
        <validation-observer ref="EditEmployeeTrainingForm" v-slot="{ invalid, handleSubmit }">
          <b-form @submit.prevent="handleSubmit(updateEmployeeTraining)">
            <b-row>
               <!-- Training Name -->
<b-col cols="12">
    <b-form-group label="Training Name" label-for="trainingName">
      <validation-provider name="Training Name" rules="required" v-slot="{ errors }">
        <b-form-input id="trainingName" v-model="editFormData.trainingName" />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </b-col>
  
  <!-- Provider -->
  <b-col cols="12">
    <b-form-group label="Provider" label-for="provider">
      <validation-provider name="Provider" rules="required" v-slot="{ errors }">
        <b-form-input id="provider" v-model="editFormData.provider" />
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
  </b-col>
  
  <!-- Training Date -->
  <b-col cols="12">
    <b-form-group label="Training Date" label-for="trainingDate">
        <b-form-datepicker id="trainingDate" v-model="editFormData.trainingDate" />
    </b-form-group>
  </b-col>

   <!-- Certification Date -->
   <b-col cols="7" v-if="editFormData.certificationIssued">
    <b-form-group label="Certification Date" label-for="certificationDate">
        <b-form-datepicker id="certificationDate" v-model="editFormData.certificationDate" />
    </b-form-group>
  </b-col>
  
  <!-- Status -->
  <b-col cols="5">
    <b-form-group label="Status" label-for="status">
        <b-form-select id="status" v-model="editFormData.status" :options="statusOptions">
          <template #first>
            <option disabled value="">Please select a status</option>
          </template>
        </b-form-select>
    </b-form-group>
  </b-col>
  

  
  <!-- Cost -->
  <b-col cols="6">
    <b-form-group label="Cost" label-for="cost">
        <b-form-input id="cost" type="number" v-model="editFormData.cost" />
    </b-form-group>
  </b-col>

    <!-- Budget -->
    <b-col cols="6">
      <b-form-group label="Budget" label-for="budget">
          <b-form-input id="budget" type="number" v-model="editFormData.budget" />
      </b-form-group>
    </b-col>
  
 

    <!-- Score -->
    <b-col cols="6">
      <b-form-group label="Score" label-for="score">
          <b-form-input id="score" type="number" v-model="editFormData.score" />
      </b-form-group>
    </b-col>

     <!-- Rating -->
  <b-col cols="6">
    <b-form-group label="Rating" label-for="rating">
        <b-form-input id="rating" type="number" v-model="editFormData.rating" />
    </b-form-group>
  </b-col>
 

  <b-col cols="6">
            <b-form-group label="TrainingType" label-for="trainingtype">
                <b-form-select id="trainingType" v-model="editFormData.trainingType" :options="trainingOptions">
                  <template #first>
                    <option disabled value="">select Training Type</option>
                  </template>
                </b-form-select>
            </b-form-group>
          </b-col>
  
  <!-- Feedback -->
  <b-col cols="12">
    <b-form-group label="Feedback" label-for="feedback">
        <b-form-textarea id="feedback" v-model="editFormData.feedback" />
    </b-form-group>
  </b-col>
  
  <!-- Training Description -->
  <b-col cols="12">
    <b-form-group label="Training Description" label-for="trainingDescription">
        <b-form-textarea id="trainingDescription" v-model="editFormData.trainingDescription" />
    </b-form-group>
  </b-col>
  
  <!-- Certification Issued -->
  <b-col cols="12">
    <b-form-group   label-for="certificationIssued">
      <b-form-checkbox id="certificationIssued" v-model="editFormData.certificationIssued">
        Is Certificate Issued?
      </b-form-checkbox>
    </b-form-group>
  </b-col>
            </b-row>
            
            <b-button type="submit" variant="primary"  @click="updateEmployeeTraining()">
                <b-spinner small v-if="submitting"></b-spinner>
                {{ submitting ? 'updating...' : 'Update Training' }}
              </b-button>

          </b-form>
      </validation-observer>
      </b-modal>
    </div>
  </template>
  
  <script>
  import {
    BTable,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BModal,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BCardBody,
    BInputGroupAppend,
    BButton,
    BCard,
    BDropdown,
    BDropdownItem,
    BFormDatepicker,
    BFormTextarea,
    BFormCheckbox,
  } from "bootstrap-vue";
  import Swal from 'sweetalert2';
  import { ValidationProvider, ValidationObserver } from "vee-validate";
  import { mapActions, mapGetters } from "vuex";
  import { customLoader, customError, customSwal } from '@/libs/customFn';
  import { extend } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  
  // Extend the 'required' rule
  extend('required', {
    ...required,
    message: 'This field is required',
  
  });
  
  export default {
    components: {
      BCard,
      BTable,
      BBadge,
      BRow,
      BCol,
      BFormGroup,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormInput,
      BInputGroupAppend,
      BButton,
      BModal,
      BDropdown,
      BDropdownItem,
      ValidationProvider,
      ValidationObserver,
      BFormDatepicker,
      BFormTextarea,
      BFormCheckbox,
      BCardBody
    },
  
  
    props: {
    },
    data() {
      return {
        perPage: 5,
        pageOptions: [3, 5, 10],
        totalRows: 1,
        currentPage: 1,
        filter: null,
        filterOn: ["trainingName", "feedback", "trainingDescription"], // Adjust this based on your filter fields
        employeeTrainingFields: [
          { key: "trainingName", label: "Training Name", sortable: true },
          { key: "provider", label: "Provider", sortable: true },
          { key: "trainingDate", label: "Training Date", sortable: true },
          { key: "trainingDescription", label: "Training Description", sortable: true },
          { key: "certificationDate", label: "Certification Date", sortable: true },
          { 
            key: "certificationIssued", 
            label: "Certification Issued", 
            sortable: true,
            formatter: (value, key, item) => value ? 'Yes' : 'No',
          },
          { key: "budget", label: "Budget", sortable: true },
          { key: "cost", label: "Cost", sortable: true },
          { key: "rating", label: "Rating", sortable: true },
          { key: "feedback", label: "feedback", sortable: true },
          { key: "score", label: "Score", sortable: true },
          { key: "trainingType", label: "Training Type", sortable: true },
          { key: "status", label: "Status", sortable: true },
          { key: "actions", label: "Actions" },
        ],
        sortBy: null,
        sortDesc: false,
        employeeId:null,
        formData: {
        id: "",
        employeeId: "",
        status: 'Not_Started',
        score: 0,
        feedback: '',
        trainingName: "",
        trainingDescription: '',
        trainingDate: new Date().toISOString().split("T")[0],
        provider: "",
        certificationIssued: false,
        cost: 0,
        rating: 0,
        budget: 0,
        trainingType: "Online"
      },

      editFormData: {
        id: "",
        employeeTrainingId: "",
        employeeId: "",
        status: "",
        score: "",
        feedback: "",
        trainingName: "",
        trainingDescription: "",
        trainingDate: "",
        provider: "",
        certificationIssued: false,
        certificationDate: "",
        cost: "",
        rating: "",
        budget: "",
        trainingType: "Online"
      },

      viewFormData: {
        id: "",
        employeeId: "",
        status: "",
        score: "",
        feedback: "",
        trainingName: "",
        trainingDescription: "",
        trainingDate: "",
        provider: "",
        certificationIssued: false,
        certificationDate: "",
        cost: "",
        rating: "",
        budget: "",
        trainingType: ""
      },
      statusOptions: [
        { value: "Completed", text: "Completed" },
        { value: "In_Progress", text: "In Progress" },
        { value: "Not_Started", text: "Not Started" },
      ],
      trainingOptions: [
        { value: "Online", text: "Online" },
        { value: "FacetoFace", text: "Face To Face" },
        { value: "Mission", text: "Mission" },
      ],
      statusVariants: {
        Completed: "success",
        In_Progress: "warning",
        Not_Started: "danger",
      },
        sortDirection: "asc",
        statusVariants: {
          0: 'warning',
          1: 'success',
          2: 'danger',
        },
      };
    },
    async mounted() {
      const id = this.employeeId = this.$route.params.id;
      await this.getEmployeeTrainingListAction(id);
      
    },
    computed: {
        ...mapGetters("employeeTrainingModule", {
      employeeTrainings: "employeeTrainings",
      employeeTrainingId: "employeeTrainingId",
    }),
    filteredEmployeeTrainings() {
    let filtered = this.employeeTrainings || [];

    // Filter logic
    if (this.filter) {
      const search = this.filter.toLowerCase();
      filtered = filtered.filter(item =>
        Object.keys(item).some(key =>
          String(item[key]).toLowerCase().includes(search)
        )
      );
    }

    // Set total for pagination
    this.totalRows = filtered.length;

    return filtered;
  }
    },
    methods: {
      ...mapActions("employeeTrainingModule", ["getEmployeeTrainingListAction", "addEmployeeTrainingAction", "updateEmployeeTrainingAction" ,"removeEmployeeTrainingAction", "getEmployeeTrainingByIDAction"],),
      refreshData() { },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        console.log("🚀 ~ onFiltered ~ totalRows:", totalRows)
        this.currentPage = 1;
      },

      resetForm() {
    this.formData = {
      trainingName: '',
      provider: '',
      trainingDate: new Date().toISOString().split("T")[0],
      status: 'Not_Started',
      score: 0,
      cost: 0,
      rating: 0,
      budget: 0,
      trainingType: "Online",
      certificationDate: null,
      feedback: '',
      trainingDescription: '',
      certificationIssued: false,
    };
    this.editFormData= {
        id: "",
        employeeTrainingId: "",
        employeeId: "",
        status: null,
        score: null,
        feedback: null,
        trainingName: "",
        trainingDescription: null,
        trainingDate: new Date().toISOString().split("T")[0],
        provider: "",
        certificationIssued: false,
        certificationDate: null,
        cost: null,
        rating: null,
        budget: null,
      },

      this.viewFormData= {
        id: "",
        employeeId: "",
        status: null,
        score: null,
        feedback: null,
        trainingName: "",
        trainingDescription: null,
        trainingDate: null,
        provider: "",
        certificationIssued: false,
        certificationDate: null,
        cost: null,
        rating: null,
        budget: null,
      };
 },

      getStatusText(status) {
      const option = this.statusOptions.find((opt) => opt.value === status);
      return option ? option.text : status; 
    },

    getBadgeColor(status) {
  switch (status) {
    case "Completed":
      return "#28a745";  
    case "In_Progress":
      return "#ffc107"; 
    case "Not_Started":
      return "#dc3545"; 
    default:
      return "#6c757d"; 
  }
},

      formatTrainingDate: (employeeTrainings) =>
      new Date(employeeTrainings.trainingDate).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }),

        formatCertificationDate: (employeeTrainings) =>
  employeeTrainings.certificationDate
    ? new Date(employeeTrainings.certificationDate).toLocaleDateString("en-GB", {
      day: "2-digit",
    month: "short",
    year: "numeric",
      })
    : "",
  
        showAddEmployeeTrainingModal() {
        this.$refs.modalAddEmployeeTraining.show();
      },
      showViewEmployeeTrainingModal(item) {
        this.viewFormData = item;
        this.$refs.modalViewEmployeeTraining.show();
      },
  
      showEditEmployeeTrainingModal(item) {
        this.editFormData = item
        this.$refs.modalEditEmployeeTraining.show();
      },
  
      async addNewEmployeeTraining() {
        this.submitting = true;
  
        const isValid = await this.$refs.AddEmployeeTrainingForm.validate();
        if (isValid) {
          try {
            this.formData.employeeId = this.$route.params.id
            if(this.formData.status == null){
              this.formData.status = "Not_Started"
            }
            if(this.formData.trainingType == null){
              this.formData.trainingType = "Online"
            }
            const payload = this.formData
            await this.addEmployeeTrainingAction(payload).then((response) => {
              if (response.data.success) {
                customSwal('Employee training has been added', 'Success', 'success');
              } else {
                customError(response, 'Error');
              }
            }).catch((error) => {
              customError(error.response.data, "Error");
            });
            
        
          } catch (error) {
            this.error(error.response.data);
          } finally {
            this.submitting = false;
            this.$refs.modalAddEmployeeTraining.hide();
            this.resetForm();
            await this.getEmployeeTrainingListAction(this.employeeId);
            this.filteredEmployeeTrainings();
          }
        } else {
          this.submitting = false;
        }
      },

  async updateEmployeeTraining() {
    this.submitting = true;

    const isValid = await this.$refs.EditEmployeeTrainingForm.validate();
    if(isValid){
  this.editFormData.employeeTrainingId = this.editFormData.id
  const payload = this.editFormData;

  try {
    const response = await this.updateEmployeeTrainingAction(payload);
    if (response.data.success) {
      customSwal('Employee training has been updated', 'Success', 'success');
    } else {
        this.submitting = false;
      customError(response, 'Error');
    }
  } catch (error) {
    this.submitting = false;
    customError(error.response.data, "Error");
  } finally {
    this.submitting = false;
    this.$refs.modalEditEmployeeTraining.hide()
    this.resetForm();
    await this.getEmployeeTrainingListAction(this.employeeId);
    this.filteredEmployeeTrainings();
  }
}else{
    this.submitting = false;
}
},
   
confirmDeleteEmployeeTraining(id) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.deleteEmployeeTraining(id);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.fire({
              title: "Cancelled",
              text: "Your employee training is safe.",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          }
        });
      },
     async deleteEmployeeTraining(id) {
        this.deleteTrainingLoader = customLoader('Please wait while training is being removed');
        this.editFormData.employeeTrainingId = id;
      await  this.removeEmployeeTrainingAction(this.editFormData.employeeTrainingId).then((result) => {
        if(result.data.success){
          this.deleteTrainingLoader.close();
          customSwal("Employee training has been removed", "Success");
            this.getEmployeeTrainingListAction(this.employeeId);
            this.filteredEmployeeTrainings();
        }
        })
          .catch((error) => {
            this.deleteTrainingLoader.close();
            customError(error.response.data, "Error");
          });
      },
      exportToCSV() {
  if (!this.employeeTrainings || this.employeeTrainings.length === 0) {
    alert("No data to export!");
    return;
  }

  // Define column headers
  let csvContent = "data:text/csv;charset=utf-8,\uFEFF";
csvContent += "Training Name,Provider,Training Date,Training Description,Certification Date,Certification Issued,Budget,Cost,Rating,feedback,Score,Training Type,Status\n";

  let employeeTrainingDetail = this.employeeTrainings;
  // Append data rows
  employeeTrainingDetail.forEach(item => {
    let row = [
      item.trainingName,
      item.provider,
      this.formatTrainingDate(item),
      item.trainingDescription,
      item.certificationDate ? this.formatCertificationDate(item) : "",
      item.certificationIssued ? "Yes" : "No",
      item.budget,
      item.cost,
      item.rating,
      item.feedback,
      item.score,
      item.trainingType,
      item.status,
      
    ].map(field => `"${String(field).replace(/"/g, '""')}"`).join(",");

    csvContent += row + "\n";
  });

  // Create a downloadable link
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", `Employee_Training_${new Date().toISOString().slice(0, 10)}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

    },
  };
  </script>